import { PageObject } from '@models/page-object.model';
import { Base } from '@testsigmainc/models';
import dayjs from 'dayjs';
import { serializable, custom, SKIP, deserialize } from 'serializr';

export class ScheduledMaintenance extends Base implements PageObject {
  serialize(): JSON {
    throw new Error('Method not implemented.');
  }

  @serializable
  public id: number;
  @serializable
  public message: string;
  @serializable(
    custom(
      () => SKIP,
      (v) => {
        if (v) return dayjs(v);
      },
    ),
  )
  public expiry: Date;
  @serializable
  public isActive: boolean;

  deserialize(input: any): this {
    return Object.assign(this, deserialize(ScheduledMaintenance, input));
  }

  get show() {
    return this.isActive && dayjs(this.expiry).diff(dayjs()) > 0;
  }
}
